import { useAuth } from '../contexts/AuthContext';
import { RolePermissions } from '../config/roles';

interface UseUserDataReturn {
    userID: string;
    email: string;
    name: string;
    role: string;
    permissions: RolePermissions;
    canView: boolean;
    canEdit: boolean;
    canDelete: boolean;
    adminView: boolean;
    pages: RolePermissions['pages'];
    isAuthenticated: boolean;
    isLoading: boolean;
}

/**
 * Custom hook to easily access user data fields and permissions
 *
 * Usage:
 * const { userID, email, name, role, canView, canEdit, canDelete, adminView } = useUserData();
 */
export const useUserData = (): UseUserDataReturn => {
    const { user, permissions, isAuthenticated, isLoading } = useAuth();

    return {
        userID: user?.userID || '',
        email: user?.email || '',
        name: user?.name || '',
        role: user?.role || '',
        permissions,
        canView: permissions.canView,
        canEdit: permissions.canEdit,
        canDelete: permissions.canDelete,
        adminView: permissions.adminView,
        pages: permissions.pages,
        isAuthenticated,
        isLoading
    };
};